// See docs/loadable-components.md for details regarding **.imports-X.** file extension & duplicate file structure.
import React from 'react';
import loadable from '@loadable/component';
import { Skeleton } from '@material-ui/lab';
import retry from '../../../utils/retry';

const Footer = loadable(() => retry(() => import('./Footer')), { fallback: <Skeleton height="100px" variant="rect" /> });

export default Footer;
